
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/avtor/[alias]",
      function () {
        return require("private-next-pages/avtor/[alias]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/avtor/[alias]"])
      });
    }
  